import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OnlineNipFieldsService {
  /**
   * @description
   * Services that end with an extension '-fields.service.ts'
   * are only used to write the configuration for the form builder component.
   * Here you can define all the fields as well as the layout of the form.
   */

  /**
   * * Table header
   */
  tableHeader = [
    {
      field: 'batch',
      header: 'Broj RN',
      sort: {
        sortDirection: 'asc',
        sortParam: 'batch',
        activeSort: false,
      }, 
      isLink: true,
      linkFunction: (rowData:any) => `/nip/edit/${rowData.id}`
    },
    {
      field: 'partner',
      header: 'Partner',
      sort: {
        sortDirection: 'asc',
        sortParam: 'partner_name',
        activeSort: false,
      },
    },
    {
      field: 'date',
      header: 'Datum otvaranja',
      sort: {
        sortDirection: 'asc',
        sortParam: 'created_at',
        activeSort: false,
      },
    },
    {
      field: 'deadline',
      header: 'Rok izrade',
      sort: {
        sortDirection: 'asc',
        sortParam: 'deadline',
        activeSort: false,
      },
    },
    {
      field: 'status',
      header: 'Status RN',
      sort: {
        sortDirection: 'asc',
        sortParam: 'status_name',
        activeSort: false,
      },
    },
    {
      field: 'current_operation',
      header: 'Trenutna operacija',
      sort: {
        sortDirection: 'asc',
        sortParam: 'current_product_operation_rel_id',
        activeSort: false,
      },
    },
    {
      field: 'note',
      header: 'Napomena',
    },

    {
      field: 'productDetails',
      header: 'Detalji proizvoda',
      custom: true,
      options: {
        width: 'width:6rem',
      },
    },
    {
      field: 'finalProcess',
      header: 'Završeni procesi',
      custom: true,
      options: {
        width: 'width:6rem',
      },
    },
  ];

  /**
   * * Product table header
   */
  productTableHeader = [
    {
      field: 'product_name',
      header: 'Naziv proizvoda',
    },
    {
      field: 'product_code',
      header: 'Sifra proizvoda',
    },
    {
      field: 'required_units',
      header: 'Kolicina',
    },

    {
      field: 'product_type',
      header: 'Tip proizvoda',
    },
    {
      field: 'total_remaining_time',
      header: 'Preostalo vreme izrade naloga (min)',
    },
    {
      field: 'total_product_estimated_time',
      header: 'Plan. vreme izrade (min/kom)',
    },
  ];

  /**
   * * Product table header
   */
  finalProcessTableHeader = [
    {
      field: 'product_name',
      header: 'Naziv proizvoda',
    },
    {
      field: 'product_code',
      header: 'Sifra proizvoda',
    },
    {
      field: 'required_units',
      header: 'Kolicina',
    },

    {
      field: 'product_package',
      header: 'Pakovanje',
    },
    {
      field: 'product_type',
      header: 'Tip proizvoda',
    },
    {
      field: 'total_remaining_time',
      header: 'Preostalo vreme izrade naloga (min)',
    },
    {
      field: 'total_product_estimated_time',
      header: 'Plan. vreme izrade (min/kom)',
    },
  ];
  constructor() {}
}
